import { GoalsAndInterventionsNotesProps } from '@web-app/components/GoalsList/types';
import { Note } from '@web-app/server/api/types';

export const getNotesDataV3 = (
  note?: Partial<Note>,
): GoalsAndInterventionsNotesProps => ({
  providerNotes: note?.sessionNote?.providerNotes || '',
  currentGlobalInterventions: {
    clientGoalsAndIntentions: note?.clientGoals?.clientGoalsAndIntentions ?? '',
    actionableIntervention: note?.clientGoals?.actionableIntervention || '',
    comments: note?.clientGoals?.comments || '',
  },
  isGoalsAndInterventionsEditorOpen:
    note?.clientGoals?.isGoalsAndInterventionsEditorOpen || false,
  currentlySelectedGoalIndex:
    note?.clientGoals?.currentlySelectedGoalIndex ?? null,
  selectedClientGoalsAndInterventions: note?.clientGoals
    ?.selectedClientGoalsAndInterventions
    ? JSON.parse(note?.clientGoals?.selectedClientGoalsAndInterventions)
    : [],
});
